export default __webpack_public_path__ + "static/media/12.29d4d637.jpg";